 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		72: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		72: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","9":"component---src-pages-404-js","10":"component---src-pages-about-js","11":"component---src-pages-aws-js","12":"component---src-pages-bot-platform-apple-messages-for-business-js","13":"component---src-pages-bot-platform-facebook-js","14":"component---src-pages-bot-platform-google-business-messages-js","15":"component---src-pages-bot-platform-index-js","16":"component---src-pages-bot-platform-telegram-js","17":"component---src-pages-bot-platform-viber-js","18":"component---src-pages-caab-js","19":"component---src-pages-case-studies-js","20":"component---src-pages-certification-confirm-js","21":"component---src-pages-certification-index-js","22":"component---src-pages-certification-junior-js","23":"component---src-pages-cloud-js","24":"component---src-pages-code-js","25":"component---src-pages-communication-js","26":"component---src-pages-download-js","27":"component---src-pages-education-index-js","28":"component---src-pages-events-js","29":"component---src-pages-faq-js","30":"component---src-pages-form-caab-js","31":"component---src-pages-form-certification-corp-js","32":"component---src-pages-form-certification-employees-js","33":"component---src-pages-form-certification-partner-js","34":"component---src-pages-form-extended-trial-js","35":"component---src-pages-form-index-js","36":"component---src-pages-form-live-demo-js","37":"component---src-pages-form-sales-js","38":"component---src-pages-form-submit-vacancy-js","39":"component---src-pages-form-support-js","40":"component---src-pages-form-unsubscribe-js","41":"component---src-pages-form-webinar-js","42":"component---src-pages-form-workshop-js","43":"component---src-pages-index-js","44":"component---src-pages-iot-js","45":"component---src-pages-jobs-js","46":"component---src-pages-knowledge-js","47":"component---src-pages-learn-js","48":"component---src-pages-live-session-js","49":"component---src-pages-manage-api-js","50":"component---src-pages-media-js","51":"component---src-pages-new-pricing-private-cloud-js","52":"component---src-pages-new-pricing-public-cloud-js","53":"component---src-pages-new-pricing-success-js","54":"component---src-pages-new-pricing-support-js","55":"component---src-pages-partnership-js","56":"component---src-pages-people-js","57":"component---src-pages-pricing-js","58":"component---src-pages-pricing-pay-js","59":"component---src-pages-pricing-private-cloud-js","60":"component---src-pages-pricing-public-cloud-js","61":"component---src-pages-pricing-support-js","62":"component---src-pages-privacy-policy-js","63":"component---src-pages-processes-js","64":"component---src-pages-product-js","65":"component---src-pages-recycling-software-js","66":"component---src-pages-software-js","67":"component---src-pages-terms-and-conditions-js","68":"component---src-pages-tutorials-js","69":"component---src-pages-workshops-js","70":"component---src-templates-blog-blog-js","71":"component---src-templates-post-post-js"}[chunkId]||chunkId) + "-" + {"0":"6e8bbf35fa815d151f2d","1":"b03a9b8451eab111fa25","2":"df813edc195518c6c475","3":"76d6839aab233f667fda","4":"d1caaa224578e210622f","5":"684984e9276a814990e1","6":"eeccf1b083a8f60ba21f","7":"724c34a4e644d08f0138","9":"8dc472ac030582b864f8","10":"276274b1063515e35284","11":"2b1bc8397a2bb9409551","12":"5d214a75fa4eeafe82bb","13":"777eb1eb66635190d9a4","14":"322e23c49b44f82ccf81","15":"8ac8c27195c4d0d29b59","16":"da12cb08ba09005a1d36","17":"8be9542050fcb5f0a3c8","18":"5714b7f8cf5e44be3ced","19":"eb8c95a3193957760657","20":"c5d1f3384fc1e46e7789","21":"f3afb1476eb67a7c7423","22":"89a8d99903311ad3ddee","23":"25d18386cbbad2a95e3b","24":"79d5c92ca618c52999bb","25":"abde7c92c43841c70158","26":"6b9876ec9caaae9fcd6c","27":"4a5bb9a8acda85cca3c5","28":"d1165b838e0fe5ccea33","29":"c8c5c8a7ac7a4f315ee1","30":"76f19763f14cf54b18d6","31":"5e3a1993934296a274f4","32":"9c48459992a97274f489","33":"a18969c039eda0c35315","34":"f1f41b746cab72f5e3a8","35":"72d6aa0cadfe0b906b6a","36":"fedd3dc78b73441e672a","37":"aa4ab850544040886097","38":"14a2232c57482bcb2274","39":"0ba5e928d49397bf08a2","40":"b92507125e372f67410e","41":"a0f107ccb1ced36f82e6","42":"ed602e6d43d49a93202c","43":"0acbf012adcea954a73f","44":"a6a405fbdb63bd63b519","45":"9e471a27201d51400d11","46":"c2a53eb96bc4b3993ee6","47":"f980fc8483ffe07fadc3","48":"2c98dfa3cdfc7e6336d7","49":"ba41b0659db05327efed","50":"e5f96f8107f1a485bfc1","51":"9e4db1fbb1889abeac18","52":"f98eaba81d74df6ab330","53":"7eb7de32e1df06606328","54":"130411a7f483aedfc257","55":"f412993af8fd8d56f273","56":"417bf23f6a151fc9b309","57":"a7d47c261a6c00ccfdc9","58":"a2b2a03abd32361605ab","59":"29944dcf42a1e33d8d5a","60":"6e187f65a4fb7274d062","61":"913f8da50e85c8ee7be7","62":"9a91e5f81e5b4edac8eb","63":"39976e9d2207c391939c","64":"01143a2b19f931b5602d","65":"464922867c234f130964","66":"18eacbd47ef0131802f3","67":"867628a0eedcdd129638","68":"db943c12202ffcd54f8b","69":"f845f4483930ff0288bd","70":"bfbfda3257d5d0c61802","71":"8f02a80c32aad7de34e5","73":"51eb512bda976208f939","74":"6dea0d8cba345a20f7ae"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","9":"component---src-pages-404-js","10":"component---src-pages-about-js","11":"component---src-pages-aws-js","12":"component---src-pages-bot-platform-apple-messages-for-business-js","13":"component---src-pages-bot-platform-facebook-js","14":"component---src-pages-bot-platform-google-business-messages-js","15":"component---src-pages-bot-platform-index-js","16":"component---src-pages-bot-platform-telegram-js","17":"component---src-pages-bot-platform-viber-js","18":"component---src-pages-caab-js","19":"component---src-pages-case-studies-js","20":"component---src-pages-certification-confirm-js","21":"component---src-pages-certification-index-js","22":"component---src-pages-certification-junior-js","23":"component---src-pages-cloud-js","24":"component---src-pages-code-js","25":"component---src-pages-communication-js","26":"component---src-pages-download-js","27":"component---src-pages-education-index-js","28":"component---src-pages-events-js","29":"component---src-pages-faq-js","30":"component---src-pages-form-caab-js","31":"component---src-pages-form-certification-corp-js","32":"component---src-pages-form-certification-employees-js","33":"component---src-pages-form-certification-partner-js","34":"component---src-pages-form-extended-trial-js","35":"component---src-pages-form-index-js","36":"component---src-pages-form-live-demo-js","37":"component---src-pages-form-sales-js","38":"component---src-pages-form-submit-vacancy-js","39":"component---src-pages-form-support-js","40":"component---src-pages-form-unsubscribe-js","41":"component---src-pages-form-webinar-js","42":"component---src-pages-form-workshop-js","43":"component---src-pages-index-js","44":"component---src-pages-iot-js","45":"component---src-pages-jobs-js","46":"component---src-pages-knowledge-js","47":"component---src-pages-learn-js","48":"component---src-pages-live-session-js","49":"component---src-pages-manage-api-js","50":"component---src-pages-media-js","51":"component---src-pages-new-pricing-private-cloud-js","52":"component---src-pages-new-pricing-public-cloud-js","53":"component---src-pages-new-pricing-success-js","54":"component---src-pages-new-pricing-support-js","55":"component---src-pages-partnership-js","56":"component---src-pages-people-js","57":"component---src-pages-pricing-js","58":"component---src-pages-pricing-pay-js","59":"component---src-pages-pricing-private-cloud-js","60":"component---src-pages-pricing-public-cloud-js","61":"component---src-pages-pricing-support-js","62":"component---src-pages-privacy-policy-js","63":"component---src-pages-processes-js","64":"component---src-pages-product-js","65":"component---src-pages-recycling-software-js","66":"component---src-pages-software-js","67":"component---src-pages-terms-and-conditions-js","68":"component---src-pages-tutorials-js","69":"component---src-pages-workshops-js","70":"component---src-templates-blog-blog-js","71":"component---src-templates-post-post-js"}[chunkId]||chunkId) + "." + {"0":"ed6d95f99e7e5fdb3c76","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
